/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Divider, Flex, Icon, Text } from '@tonic-one/react';
import { DeleteIcon, EditIcon } from '@tonic-one/react-icons';
import { dataAttr } from '@tonic-one/utils';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useWhyDidYouUpdate } from 'src/utils/hooks';
// import { useMenusItemStyle } from '../CasHeader/AccountSetting/style';
import { SearchInput } from '../CasTreeTransfer/Components';
import IconButton from '../IconButton';
import { TargetListProvider, useTargetListContext } from './context';
import useTargetListStyle from './style';
import { TreeNode } from '../Tree/type';

function searchList<T>(list: T[], value: string) {
  return list.filter((item: any) => {
    return item['title'].toLowerCase().includes(value.toLowerCase());
  });
}
export const FlexOption = ({
  style,
  action,
  ...props
}: {
  action?: {
    delete?: {
      icon?: {
        name: string;
        component: JSX.Element;
      };
      handler: Function;
      disabled?: boolean;
    };
    edit?: {
      icon?: {
        name: string;
        component: JSX.Element;
      };
      handler: Function;
      disabled?: boolean;
    };
  };
  [key: string]: any;
}) => {
  // console.log(style, action);
  const { optionStyle } = useTargetListStyle();
  useWhyDidYouUpdate('TargetList-FlexOption', { style, action, ...props });
  if (action) {
    return (
      <Flex
        alignItems="center"
        height="8x"
        minHeight="8x"
        px="3x"
        justifyContent="space-between"
        {...optionStyle}
        {...props}
        {...style}
        data-selected={dataAttr(props.selected)}
        data-value={props.value}
      >
        <Flex data-value={props.value} wordBreak="break-all">
          {props.children}
        </Flex>
        <Flex>
          {action.delete && (
            <IconButton
              disabled={action?.delete?.disabled || false}
              mr="1x"
              onClick={() => {
                action?.delete?.handler(props.value);
              }}
            >
              {action.delete.icon ? (
                action.delete.icon.component
              ) : (
                <Icon as={DeleteIcon} />
              )}
            </IconButton>
          )}
          {action.edit && (
            <IconButton
              disabled={action?.edit?.disabled || false}
              onClick={() => {
                action?.edit?.handler(props.value);
              }}
            >
              {action.edit.icon ? (
                action.edit.icon.component
              ) : (
                <Icon as={EditIcon} />
              )}
            </IconButton>
          )}
        </Flex>
      </Flex>
    );
  } else {
    return (
      <Flex
        alignItems="center"
        height="8x"
        minHeight="8x"
        px="3x"
        justifyContent="space-between"
        {...optionStyle}
        {...props}
        data-selected={dataAttr(props.selected)}
        data-value={props.value}
      >
        <Flex data-value={props.value} wordBreak="break-all">
          {props.children}
        </Flex>
      </Flex>
    );
  }
};
const FlexList = ({ style, ...props }: { [key: string]: any }) => {
  // console.log(style);
  useWhyDidYouUpdate('TargetList-FlexList', { style, ...props });
  const styles = useTargetListStyle();
  const { flexListStyle } = styles;
  const newStyle = { ...flexListStyle, ...style };
  return <Flex style={newStyle} {...props} />;
};
// limit as -1, means no limit
const TargetList = React.memo(
  (props: {
    list: TreeNode[];
    //   onAdd?: Function;
    disabled: boolean;
    limit: number;
    width: string;
    multipleSelect?: boolean;
    onSelect?: Function;
    onDelete?: Function;
    onEdit?: Function;
    size?: number;
    title?: string;
    description?: string;
    placeholder?: string;
    onImport?: Function;
    onExport?: Function;
    [key: string]: any;
  }) => {
    const { t } = useTranslation();
    const { descriptionStyle } = useTargetListStyle();
    const {
      inputValue,
      handleSearchValueChange,
      displayList,
      handleDisplayListChange,
      handleReadonlyListChange,
      readonlyList,
    } = useTargetListContext();
    const prefixRef = React.useRef(Math.random().toString(36).slice(4));
    const {
      list,
      onDelete,
      onEdit,
      // onAdd,
      onImport,
      onExport,
      disabled,
      // limit,
      description,
      width,
      size,
      placeholder,
      title,
      multipleSelect,
      onSelect,
    } = props;
    const height = React.useMemo(() => {
      const baseHeight = 86;
      const showSize = size || 4;
      const height = baseHeight + showSize * 32;
      return `${height}px`;
    }, [size]);
    const action = React.useMemo(() => {
      const action: any = {};
      if (onDelete) {
        action['delete'] = {
          handler: onDelete,
          disabled,
        };
      }
      if (onEdit) {
        action['edit'] = {
          handler: onEdit,
          disabled,
        };
      }
      return action;
    }, [onDelete, onEdit, disabled]);
    const isMultipleSelect = React.useMemo(
      () => !!multipleSelect,
      [multipleSelect]
    );
    const [selectedItems, setSelectedItems] = React.useState<any[]>([]);
    const handleOptionClick = React.useCallback(
      (e: any) => {
        const key = e.target.dataset.value;
        if (isMultipleSelect) {
          const index = selectedItems.indexOf(key);
          if (index > -1) {
            setSelectedItems([
              ...selectedItems.slice(0, index),
              ...selectedItems.slice(index + 1),
            ]);
          } else {
            setSelectedItems([...selectedItems, key]);
          }
        } else {
          setSelectedItems([key]);
        }
      },
      [selectedItems]
    );
    useWhyDidYouUpdate('TargetList', {
      ...props,
      isMultipleSelect,
    });
    const handleSearchTree = React.useCallback(
      (value: string) => {
        const realValue = value.trim();
        if (realValue === '') {
          // 清空search
          handleDisplayListChange(readonlyList);
        } else {
          // search list
          handleDisplayListChange(searchList(readonlyList, realValue));
        }
      },
      [readonlyList]
    );
    // 初始化
    useEffect(() => {
      // 设置displayList
      handleDisplayListChange(list);
      // 设置只读list 供后续搜索用
      handleReadonlyListChange(list);
      handleSearchValueChange({ target: { value: '' } });
    }, [list]);
    // 选中项变化
    useEffect(() => {
      if (onSelect) {
        const items = list.filter((item) => selectedItems.includes(item.key));
        onSelect(items);
      }
    }, [selectedItems]);
    return (
      <div>
        <FlexList width={width} direction="column" height={height}>
          {title && (
            <Flex mb="12px">
              <Text>{title}</Text>
            </Flex>
          )}
          <Flex mb="12px">
            <SearchInput
              onChange={handleSearchValueChange}
              onSearch={handleSearchTree}
              value={inputValue}
              placeholder={
                placeholder || t('policy.placeholder.selectedTargets.items')
              }
              autoClear
              width="100%"
              disabled={disabled}
            />
            {onImport && (
              <Button
                ml="3x"
                variant="secondary"
                onClick={(e) => onImport(e)}
                disabled={disabled}
              >
                {t('common.action.label.import')}
              </Button>
            )}
            {onExport && (
              <Button
                ml="3x"
                variant="secondary"
                onClick={() => onExport(list)}
                disabled={disabled || list.length === 0}
              >
                {t('common.action.label.export')}
              </Button>
            )}
          </Flex>
          <Flex>
            {description && (
              <Text style={descriptionStyle} width="600px">
                {description}
              </Text>
            )}
          </Flex>
          <Divider mb="12px" />
          <Flex direction="column">
            {displayList.map((item) => {
              return (
                <FlexOption
                  value={item.key}
                  action={action}
                  key={`${prefixRef.current}-${item.key}`}
                  height="auto"
                  padding="0.25rem 0.75rem"
                  onClick={handleOptionClick}
                  selected={selectedItems.includes(item.key)}
                >
                  {item.icon ? (
                    <Flex alignItems="center" columnGap="8px">
                      {item.icon.component}
                      {item.title}
                    </Flex>
                  ) : (
                    item.title
                  )}
                </FlexOption>
              );
            })}
          </Flex>
        </FlexList>
      </div>
    );
  }
);
const TargetListWithStore = (props: any) => {
  return (
    <TargetListProvider>
      <TargetList {...props} />
    </TargetListProvider>
  );
};
export default React.memo(TargetListWithStore);
